import React, { Component } from 'react';

import Server from './Server.js'
import { connect } from "react-redux"
import Header from './Header.js'
import {  Navigate , Link } from 'react-router-dom'
import Turnover from './Turnover.js'
import { ProgressSpinner } from 'primereact/progressspinner';
import LoginBox from "./LoginBox.js";
import { Dialog } from "primereact/dialog";
import { Chip } from 'primereact/chip';
import { Divider } from 'primereact/divider';

class Admin extends React.Component {       
  constructor(props){
    super(props);  
    this.Server = new Server();
    this.state={
      Place:this.props.place,
      listViewData:[],
      Sort:"",
      HasBranch:-1,
      loading:false,
      IsSeller:-1,
    }     
    
  }
  componentDidMount() {
    let that = this;
    if(this.props.mobile){
      this.init();
    }else{
      this.setState({
        showLogin: true
      })
    }
    
  }
  init() {
  
    let that = this;
    let param = {
      token: localStorage.getItem("api_token"),
    };
    this.setState({
      loading: 1
    })
    let SCallBack = function (response) {
      if(response.data.authData.userId){
        that.setState({
          UId: response.data.authData.userId,
        })
      }
      that.getuserInformation(response.data.authData.userId);
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("MainApi/checktoken", param, SCallBack, ECallBack)
  }
  getuserInformation(UId){

    let that = this;
    let param = {
      user_id:UId
    };
    this.setState({
      loading: 1
    })
    let SCallBack = function (response) {
      that.setState({
        shopId:response.data.result ? response.data.result[0].shopId : null,
        isPayk:(response.data.result && response.data.result[0].map == "payk") ? true : false,
      })
      that.getShop(response.data.result[0].shopId);
    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("MainApi/getuserInformation", param, SCallBack, ECallBack)

  }
  getShop(shopId){
    if(this.state.isPayk){
      this.setState({
        isPayk:1,
        loading: 0

      })
      return;
    } 
    if(!shopId){
      this.setState({
        IsSeller:0,
        loading: 0

      })
      return;
    }
    let that = this;
    let param = {
      ShopId:shopId
    };
    let SCallBack = function (response) {
      
      let finalCredit = response.data.result[0]?.credit||0;

      if(response.data.result[0].wallet){
        for(let i=0;i<response.data.result[0].wallet.length;i++){
          finalCredit+=response.data.result[0].wallet[i].credit;
        }
      }
      that.setState({
        shop:response.data.result[0],
        branches:response.data.branches,
        HasBranch: (response.data.branches && response.data.branches.length > 0 ) ? 1 : 0,
        wallet : response.data.result[0]?.wallet || [],
        credit:response.data.result[0]?.credit||0,
        finalCredit:finalCredit,
        loading: 0,
        IsSeller:1
      })
     

    };
    let ECallBack = function (error) {
      that.setState({
        loading: 0
      })
      console.log(error)
    }
    this.Server.send("AdminApi/ShopInformation", param, SCallBack, ECallBack)

  }
  render() {         
   
    if (this.state.isPayk) {
      return <Navigate  to={"/Payk"} /> ;
    }
    return (   
       <div>
           <Header credit={this.state.credit} ComponentName="پذیرندگان" />
       <div> 
       <div style={{height:'100%',minHeight:500,overflow:'auto'}}>    
       <Dialog
            header="ورود به سامانه"
            visible={this.state.showLogin}
            maximized={true}
            closable={true}
            resizable={false}
            draggable={false}
            onHide={() => {
              if (this.props.mobile) {
                this.setState({
                  showLogin: false,
                });
                this.init();
              } else {
                window.history.back();
              }
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <LoginBox
                appData={this.props.appData}
                AfterLogin={() => {
                  this.setState({
                    showLogin: false,
                  });
                  this.init();
                }}
              />
            </div>
          </Dialog>
        {this.state.IsSeller == 0 &&
            <div>
            <p style={{ fontFamily: 'iranyekanwebmedium', textAlign: 'center',color:'red' }}>
               شما به عنوان پذیرنده در سیستم تعریف نشده اید
             </p>
             <p style={{ fontFamily: 'iranyekanwebmedium', textAlign: 'center' }}>
               برای ثبت نام به عنوان پذیرنده و استفاده از امکانات فروش نقدی و اقساطی محصولات خود به صورت حضوری و آنلاین با پشتیبانان سیستم تماس بگیرید
             </p>

            </div>
        }
        {this.state.IsSeller == 1 &&
            <div>
              <div style={{display:'none',justifyContent:'space-around',flexWrap:'wrap'}} >
          <div style={{width:'48%',height:100,marginTop:10}}>
            <Link style={{position:'relative',width:122,textAlign:'left'}} to={`${process.env.PUBLIC_URL}/ManageProducts`} >
              <div  style={{background:'#fff',borderRadius:7,width:'100%',height:'100%',color:'#000',textAlign:'center',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'space-around'}}>
                <img src="./icons/icon20.png?ver=1" style={{width:70}} />
                <span className="iranyekanwebmedium" >محصولات</span>
              </div>
            </Link>
          </div>

          <div style={{width:'48%',height:100,marginTop:10}}>
            <Link style={{position:'relative',width:122,textAlign:'left'}} to={`${process.env.PUBLIC_URL}/Factors`} >
              <div  style={{background:'#fff',borderRadius:7,width:'100%',height:'100%',color:'#000',textAlign:'center',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'space-around'}}>
                <img src="./icons/icon21.png?ver=1" style={{width:70}} />
                <span className="iranyekanwebmedium" >سفارشات آنلاین</span>
              </div>
            </Link>
          </div>


        </div>
        <hr style={{borderColor:'#eaeaea42'}} />
            <div style={{display:'none'}}>

            {this.state.HasBranch == 0 && this.state.wallet && this.state.wallet.map((item,index)=>{
              if(item.name == "mehr" && this.state.credit){
                return(
                  <p style={{ fontFamily: 'iranyekanwebmedium', textAlign: 'center',color:'green',fontSize:17,direction:'rtl' }}>
                  {this.state.shop?.name} 
                  <Divider align="center" type="dashed">
                  <Chip label={<span>{this.state.credit.toString().replace(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ریال</span>}   />
                  </Divider>
                  
                  </p>
                )
              }else if(item.credit){
                return(
                  <p style={{ fontFamily: 'iranyekanwebmedium', textAlign: 'center',color:'green',fontSize:17,direction:'rtl' }}>
                  {this.state.shop?.name}  
                  <Divider align="center" type="dashed">
                  <Chip label={<span>{item.credit.toString().replace(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ریال</span>}   />
                  </Divider>
                  
                  </p>
                )
              }
              

            })
            
              
            }
            </div>
            {!this.state.branches || this.state.branches.length == 0 &&
              <div>
              <p style={{ fontFamily: 'iranyekanwebmedium', textAlign: 'center',color:'green',fontSize:17,direction:'rtl' }}>

                    {this.state.shop?.name}
                    <Divider align="center" type="dashed">
                    <Chip label={<span>{this.state.finalCredit.toString().replace(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")} ریال</span>}   />
                  </Divider>
                    </p>
              </div>
            }
            
              
             
              <Turnover shop="1" shopId={this.state.shopId} branches={this.state.branches} />
            </div>
        }
        {this.state.IsSeller == -1 &&
        <div style={{display:'flex',justifyContent:'center',alignItems:'center',height:'100%'}}>
            <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s"/>
        </div>
        
        }
             
        </div>
       </div>
          
    </div>
    );
  }
}
function mapStateToProps(state) {        
  return {
    username : state.username,
    password : state.password,
    ip : state.ip,
    account:state.account,
    place:state.place,
    fullname : state.fullname,
    tokenrb: state.tokenrb,
    mobile : state.mobile,
    appData:state.appData,
    creditPrice:state.creditPrice,
    systemId:state.systemId
  }
}
export default connect(mapStateToProps)(Admin)  

